"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isPostiveInteger = function (number) {
    return Number.isInteger(number) && number > 0;
};
/**
 * When given a list of Ad sizes this function will return the largest size in the list
 */
function getAdSize(sizes) {
    // initalize these two variables so that they can be used later without Typescript complaining
    var largestSizeArea = 0, largestSize = undefined;
    if (sizes.length === 0) {
        throw new Error("Invalid Size entered");
    }
    for (var _i = 0, sizes_1 = sizes; _i < sizes_1.length; _i++) {
        var size = sizes_1[_i];
        if (size.length !== 2) {
            throw new Error("Invalid Size entered");
        }
        var width = size[0];
        var height = size[1];
        if (!isPostiveInteger(width) || !isPostiveInteger(height)) {
            throw new Error("Invalid Size entered");
        }
        var currentArea = width * height;
        if (!largestSize || largestSizeArea < currentArea) {
            largestSizeArea = currentArea;
            largestSize = size;
        }
    }
    return largestSize;
}
exports.default = getAdSize;
